import styled from '@emotion/styled';

import { BRAND_COLORS, COLORS, LAYOUT } from '../../../styles/theme';
import Logo from '../../../assets/logo.png';

const Container = styled.header`
  position: sticky;
  display: flex;
  align-items: center;

  width: 100%;
  height: 4.25rem;

  background-image: url(${Logo});
  background-repeat: no-repeat;
  background-size: 11.5rem;
  background-position: right 1.4rem center;

  background-color: ${COLORS['white-50']};
  backdrop-filter: blur(1rem);

  border-bottom: 1px solid ${COLORS.alto};
  border-radius: ${LAYOUT.BORDER_RADIUS * 2}px ${LAYOUT.BORDER_RADIUS * 2}px 0 0;

  top: 0px;
  z-index: 100;
  padding: 1.5rem;

  box-shadow: 0 0 2.25rem ${COLORS['black-15']};

  & > .previous-button {
    cursor: pointer;

    font-size: 1.2rem;
    padding: 0.5rem;
    margin-right: 1rem;
    transform: scaleX(1.2);
    color: ${COLORS.silverChalice};

    &:hover {
      color: ${BRAND_COLORS.primary};
    }
  }

  & > .title {
    font-size: 1.35rem;
    font-weight: bold;
    line-height: 1.375rem;
    color: ${COLORS.dorado};
  }
`;

export default Container;
